module.exports = __webpack_public_path__ + "img/ck.960a7b5a.svg";